import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { type CaseDataObject } from "~/features/orders/orderDetails/components/ServiceCases/types";
import { moxyListMapToRecord, type MoxyListValueDTO, type MoxyMapDTO } from "~/common/types/MoxyMapDTO";

type ServiceCasesByLine = Record<string, CaseDataObject[]>;

interface OrderLineFeedbackDTO {
  feedback?: MoxyMapDTO<string, MoxyListValueDTO<CaseDataObject>>;
}

function resolveFeedbackUrl(params: string): string {
  return occUrl(`/feedback/fetch?${params}`);
}

export async function fetchServiceCases(soNumber: string): Promise<ServiceCasesByLine> {
  const apiUrl = resolveFeedbackUrl(`orderNumber=${soNumber}`);
  const response = await occFetch(apiUrl);

  try {
    const dto = (await response.json()) as OrderLineFeedbackDTO;
    return moxyListMapToRecord(dto.feedback);
  } catch (err) {
    console.error(err);
    return {};
  }
}

export async function fetchServiceCasesByLineNumber(
  soNumber: string,
  lineNumber: string,
): Promise<Record<string, CaseDataObject[]>> {
  const apiUrl = resolveFeedbackUrl(`orderNumber=${soNumber}&orderLineNumber=${lineNumber}`);
  const response = await occFetch(apiUrl);
  const dto = (await response.json()) as OrderLineFeedbackDTO;

  return moxyListMapToRecord(dto.feedback);
}

export async function addCommentByCode(code: string, message: string) {
  const apiUrl = occUrl("/feedback/update");
  const response = await occFetch(apiUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      code: code,
      feedbackMessage: message,
    }),
  });
  return await response;
}
